exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contract-after-info[data-v-1f80ecde] {\n  padding: 10px 0;\n}\n.contract-after-info h3[data-v-1f80ecde] {\n  margin-bottom: 15px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #303133;\n}\n.no-data[data-v-1f80ecde] {\n  padding: 40px 0;\n}\n.image-list[data-v-1f80ecde] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 4px;\n}\n.video-list[data-v-1f80ecde] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 4px;\n}\n", ""]);

// exports
